import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { media } from 'styles/utils';

import Container from 'components/Container';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Row from 'components/Row';
import FounderCard from 'components/FounderCard';

const Section = styled.section`
  padding: 4.5rem 1rem;
  position: relative;
  text-align: center;

  .background-image {
    height: 100%;
    left: 50%;
    maxheight: 868px;
    maxwidth: 1536px;
    top: 12rem;
    transform: translateX(-50%);
    width: 100%;
  }

  ${media.max('md')} {
    .background-image {
      display: none !important;
    }
  }
`;

const Founders = styled(Row)`
  width: 100%;
  max-width: 56rem;
`;

export default function OurFounders() {
  const data = useStaticQuery(
    graphql`
      query {
        founders: allFoundersJson {
          edges {
            node {
              id
              name
              title
              description
              link
              profile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                }
              }
            }
          }
        }
      }
    `
  );
  const founders = data.founders?.edges.map(({ node }) => node);

  return (
    <Section>
      <StaticImage
        alt=""
        className="background-image"
        height={736}
        objectFit="contain"
        objectPosition="top"
        placeholder="blurred"
        src="../../images/team/team-background.webp"
        style={{ position: 'absolute' }}
        width={1568}
      />
      <Container>
        <Stack gap="clamp(3rem, calc(4rem + 12vw), 16rem)" align="center">
          <Text as="h2" variant="heading.section">
            Our People
          </Text>
          <Founders
            colGap="1rem"
            rowGap="1rem"
            align="stretch"
            breakpoint="md"
            layout="fixed"
          >
            {founders.map((founder) => (
              <FounderCard key={founder.id} {...founder} variant="dark" />
            ))}
          </Founders>
        </Stack>
      </Container>
    </Section>
  );
}
